var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLkwb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284.6 281.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a6f51a78-9f4e-4461-a3ea-d98a33ef095e,.b2c7b674-5ddf-4bf0-b3bd-c2e087224d80{fill:#0166a8;}.a6f51a78-9f4e-4461-a3ea-d98a33ef095e{opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e6db80c0-3fbf-4a54-bb5f-8f2cac4848f8",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bb7c3745-32df-4d67-a3f2-467bb06ad01c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b2c7b674-5ddf-4bf0-b3bd-c2e087224d80",
    d: "M49.33,12.88c-7.14,6.64-11.54,16-14.92,25.8a78.22,78.22,0,0,0,117.08,90.81,78.58,78.58,0,0,1,8.45-6.45q2.09-1.38,4.24-2.61A77.83,77.83,0,0,1,261,239.72,155.13,155.13,0,0,1,49.33,12.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a6f51a78-9f4e-4461-a3ea-d98a33ef095e",
    d: "M53.21,0C46.07,6.65,41.67,16,38.29,25.81a78.23,78.23,0,0,0,117.08,90.81,77.3,77.3,0,0,1,8.45-6.45q2.09-1.38,4.24-2.62a77.84,77.84,0,0,1,96.81,119.3A155.13,155.13,0,0,1,53.21,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkwb);
export default __webpack_public_path__ + "static/media/lkwb.f6d171f30d43b8f2fe043c9a8f8f28c5.svg";
export { ForwardRef as ReactComponent };